import { Navigate, Outlet, useLocation } from 'react-router';
import useAuthStore from '../../stores/authStore.js';
import AuthPending from './AuthPending.jsx';

/**
 * Pathless layout guard for customer-only areas (account, orders, checkout).
 *
 * This is a redirect, not a security boundary. The data behind these routes is
 * protected by the API requiring a valid access token; all this does is stop a
 * signed-out visitor from staring at an empty page.
 */
export default function RequireAuth() {
  const status = useAuthStore((s) => s.status);
  const location = useLocation();

  if (status === 'unknown') return <AuthPending />;

  if (status !== 'authenticated') {
    return (
      <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }

  return <Outlet />;
}
